// extracted by mini-css-extract-plugin
module.exports = {"text":"text___2-qbz","menu":"menu___1d_tr"};